module.exports = __webpack_public_path__ + "static/media/logo_MSS.8b59e4da.png";